<template>
    <div class="merged-contacts-modal modal-card">
        <header class="modal-card-head">
            <p class="title modal-card-title">{{ title || 'Merged Similar items' }}</p>
        </header>
        <section class="modal-card-body">
          <div>
            <form class="is-clearfix">

             <o-field label="Company Name" v-model="company_name" required>
               <template #label>
                 Add New Company Name <span style="color: red">*</span>
               </template>
               <o-input class="o-input-width-auto" type="text" v-model="company_name" @update:modelValue="company_name = $event" placeholder="Company Name" />
             </o-field>
              <button class="button is-success my-2" id="btn-submit" type="submit" title="Merge" @click.prevent="handleMerge" v-if="company_name">
                Merge All <span class="icon ml-3"><i class="fa fa-compress"></i></span>
              </button>
            </form>
          </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>

    import { mapActions } from "vuex";

    export default {
        components: {
        },

        computed: {
            defaultOpenedDetails() {
                return this.data.map((i, idx) => idx)
            },

            total() {
                return !!this.data ? this.data.length : 0
            },

            transitionName() {
                return this.useTransition ? 'fade' : '';
            },
        },

        data () {
            return {
                currentPage: 1,
                isReminderModalActive: false,
                isTableVisible: true,
                loading: false,
                table: {
                    bordered: false,
                    detailed: true,
                    hoverable: true,
                    checkable: true,
                    mobileCards: true,
                    narrowed: false,
                    paginated: false,
                    paginationSimple: false,
                    perPage: 15,
                    perPageOptions: [5, 10, 15, 25, 50],
                    striped: true,
                },
                showDetailIcon: true,
                useTransition: false,
                checkedRows: [],
                company_name: null
            }
        },

        mounted () {
        },

        methods: {
          ...mapActions(["mergeSimilarDuplicatedCompanies", "mergeDuplicatedCompanies", "fetchDuplicatedCompanies"]),


            handleMerge() {
              let items = this.data.map(item => {
                item.name = this.company_name
                item.items.map(item1 => {
                  item1.name = this.company_name
                  return item1
                })
                return item
              })

                this.mergeSimilarDuplicatedCompanies(items).then(() => {
                  setTimeout(() => {
                    this.fetchDuplicatedCompanies({ exactlyName: this.company_name }).then((value) => {
                      this.mergeDuplicatedCompanies(value.data.data).then(() => {
                        this.successMessage('Items were merged successfull')
                      })
                    })
                  }, 500)

                })
            },



        },

        props: ['data', 'tableColumns', 'title'],

        watch: {
          'company_name'(value) {
            $("#btn-submit").prop('disabled', !value)
          }
        },
    }
</script>

<style lang="sass" scoped>
//.merge-companies-ctn
//  .modal
//    .animation-content
//      max-width: max-content !important


.modal-card
  min-width: 400px !important

.b-radio
  overflow: auto

.merged-contacts-modal
  width: 100% !important
  .filters-container
    align-items: center
    flex-wrap: wrap
  .merged-contacts-table
    .table-wrapper
      min-height: auto
      overflow-x: auto
      .field-ctn
        vertical-align: middle

</style>
